import api from '../../plugins/api';

const removeEquipments = ({ id }) => {
  return api.post('api/crm/equipments/removeEquipments', { id });
};

export default removeEquipments;
